import { useGetAvailableChargeAndGoCardsV2Query } from '../../codegen/paymentPartners';

type UseAvailableChargeAndGoCardsParams = { skip?: boolean };

export const useAvailableChargeAndGoCards = ({
  skip = false,
}: UseAvailableChargeAndGoCardsParams = {}) => {
  const {
    data: { items: availableCards = [] } = {},
    isLoading,
    error,
  } = useGetAvailableChargeAndGoCardsV2Query(undefined, {
    skip,
  });

  return {
    availableCards,
    isLoading,
    error,
  };
};
